import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface CaptureMethodProps {
  type: string;
}

const CaptureMethod: React.FC<CaptureMethodProps> = ({ type }) => {
  const { t } = useTranslation('provider');

  const SELECT_ID = 'capture-method-select';
  const LABEL_ID = `${SELECT_ID}-label`;

  return (
    <Box>
      <FormControl variant="filled" fullWidth>
        <InputLabel id={LABEL_ID}>{t('captureMethod')}</InputLabel>
        <Select
          readOnly
          labelId={LABEL_ID}
          id={SELECT_ID}
          label={t('captureMethod')}
          value={type}
          MenuProps={{
            className: 'select-menu',
          }}
        >
          <MenuItem value={type}>{type}</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default CaptureMethod;
